/** @typedef {{ status: number, [key: string]: any }} EcoRebatesErrorResponse */

export class EcoRebatesApiError extends Error {
  /** @type {EcoRebatesErrorResponse} */
  response;

  /** @param {EcoRebatesErrorResponse} response */
  constructor(response) {
    super(`HTTP status code: ${response.status}`);
    this.name = 'EcoRebatesApiError';
    this.response = response;
  }
}
